import { render, staticRenderFns } from "./audio-create.vue?vue&type=template&id=5dc6c8a4&"
import script from "./audio-create.vue?vue&type=script&lang=js&"
export * from "./audio-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willin/Documents/shiwangme/shiwangme_new_cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5dc6c8a4', component.options)
    } else {
      api.reload('5dc6c8a4', component.options)
    }
    module.hot.accept("./audio-create.vue?vue&type=template&id=5dc6c8a4&", function () {
      api.rerender('5dc6c8a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/views/material/audio-create.vue"
export default component.exports